import { CalendarFunctions as calFns } from "../../../components/Calendar";
import { AssessmentDocument } from "../../../interfaces/AssessmentInterfaces";

const GroupAssessmentsByDate = (
  assessments: AssessmentDocument[]
): { [key: string]: AssessmentDocument[] } => {
  const sortedAssessments = assessments.sort(
    (a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()
  );
  return sortedAssessments.reduce((acc, assessment) => {
    const { createdDate } = assessment;
    const groupKey = calFns.convertADtoBS(new Date(createdDate)).formatted5;
    const newAcc = { ...acc };
    if (!newAcc[groupKey]) {
      newAcc[groupKey] = [];
    }
    newAcc[groupKey].push(assessment);
    return newAcc;
  }, {} as { [key: string]: AssessmentDocument[] });
};

export default GroupAssessmentsByDate;
